import Message, { TMessage } from "./message";
import User, { TUser } from "./user";
import Customer, { TCustomer } from "./customer";

export type TConversation = {
  id: string;
  number: number;
  customerId: string;
  customer: TCustomer;
  status: TConversationStatus;
  priority?: TPriorityLevel;
  startedChannel: number;
  messages?: TMessage[];
  lastMessage?: TMessage;
  assignedAgent?: TUser;
  createdAt: string;
  subject: string;
  copiedCustomers?: TCustomer[];
};

export type TConversationStatus = "OPEN" | "SNOOZED" | "CLOSED" | "PENDING";

export type TPriorityLevel = 0 | 1 | 2 | 3 | 4;

export enum DeliveryType {
  CHAT = 1,
  EMAIL = 2,
  SMS = 4,
  WHATSAPP = 5,
  SLACK_CONNECT = 6,
  DISCORD_CONNECT = 7,
}

class Conversation {
  public id: string;
  public number: number;
  public customerId: string;
  public customer: Customer;
  public status: TConversationStatus;
  public priority: TPriorityLevel;
  public startedChannel: DeliveryType;
  public messages: Message[];
  public lastMessage?: Message;
  public assignedAgent?: User;
  public createdAt: string;
  public subject: string;
  public copiedCustomers: Customer[];

  constructor(data: TConversation) {
    this.id = data.id;
    this.number = data.number;
    this.customerId = data.customerId;
    this.customer = new Customer(data.customer);
    this.status = data.status;
    this.priority = data.priority || 0;
    this.startedChannel = data.startedChannel;
    this.createdAt = data.createdAt;
    this.subject = data.subject;
    this.copiedCustomers = (data.copiedCustomers || []).map(
      (c) => new Customer(c)
    );

    this.messages = (data.messages || []).map(
      (message) => new Message(message)
    );

    if (data.lastMessage) {
      this.lastMessage = new Message(data.lastMessage);
    }

    if (data.assignedAgent) {
      this.assignedAgent = new User(data.assignedAgent);
    }
  }
}

export default Conversation;
